/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetTokenForId} from '../api'

export const useMutationBatchGetTokenForId = createReactQueryMutationHook('batchGetTokenForId', batchGetTokenForId)
